import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const walletSection = "/wallet";

export const walletOffersListPath = walletSection;

export interface WalletOffersListUrlQueryParams {
  action?: "add" | "edit" | "delete";
  id?: string;
  query?: string;
}

export const walletOffersListUrl = (params?: WalletOffersListUrlQueryParams) =>
  walletOffersListPath + (params ? "?" + stringifyQs(params) : "");

export const walletCustomerSectionUrl = (customerId: string) =>
  urlJoin(walletSection, "customer", encodeURIComponent(customerId));
